<template>
  <div class="footer">
    <div>
      <div class="footer_1">
        <div class="footer_5">
          <h5>首页</h5>
          <div v-for="(item, index) in arr" :key="index">
            <button @click="toFot(item)">{{ item.str }}</button>
          </div>
        </div>
        <div class="footer_5">
          <h5>公司业务</h5>
          <div>
            <button @click="toFot1('App')">APP项目设计开发</button>
          </div>
          <div>
            <button @click="toFot1('Applets')">小程序项目设计开发</button>
          </div>
          <div>
            <button @click="toFot1('pc')">网页端设计开发</button>
          </div>
          <button style="height: 19px;"></button>
          <div>
            <img
              style="width:80px;"
              src="../image/index/indexQRcode.jpg"
              alt=""
            />
            <img
              style="width:80px;"
              src="../image/index/wechat.png"
              alt=""
            />
          </div>
        </div>
        <div class="footer_5">
          <h5>关于我们</h5>
          <div>
            <button @click="toFot2('he')">公司简介</button>
          </div>
          <div>
            <button @click="toFot2('gf')">圭峰团队</button>
          </div>
          <div>
            <button @click="toFot2('jd')">经典案例</button>
          </div>
          <div>
            <button @click="toFot2('sh')">售后服务</button>
          </div>
        </div>
        <div class="footer_5">
          <h5>联系我们</h5>
          <!-- <div>
            <p>联系电话: 13331130332</p>
          </div> -->
          <div>
            <p></p>
          </div>
          <div>
            <p>邮箱: cqgfwlkj@163.com</p>
          </div>
          <div>
            <p>联系地址: 重庆市巴南区渝南大道251号</p>
          </div>
        </div>
      </div>
      <div class="footer_2"></div>
      <div class="footer_3">
        <div
          class="flex"
          style="align-items: center;justify-content: flex-start;width: 35%;"
        >
          <img
            style="width: 20%;margin-right: 2%;"
            src="../image/index/indexWhite.png"
          />
          <div>
            <p class="pp" style="font-size: 25px;letter-spacing: 4px;">
              圭峰网络
            </p>
            <p style="letter-spacing: 3px;font-size: 12px;">guifengwangluo</p>
          </div>
        </div>
        <p style="color:#ccc;cursor:auto;display:flex;align-items: center;">
          重庆圭峰网络有限公司 版权所有 © 2019-2024
          <span style="display:flex;align-items: center;margin:0 5px 0 10px;cursor:pointer;" @click="goGonganBeian">
            <img src="../image/gongan.png" />
            <div style="font-size: 14px;">
              渝公网安备 50010702503123号
            </div>
          </span>

          <span @click="beiC" style="cursor:pointer;font-size: 14px;">渝ICP备20007850号-1</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
      arr: [
        { str: '品牌塑造', to: '/' },
        { str: '业务范围', to: '/business' },
        { str: '合作案例', to: '/cooperationA' },
        { str: '关于我们', to: '/about' },
        { str: '联系我们', to: '/contact' }
      ]
    }
  },
  methods: {
    beiC () {
      window.open('https://beian.miit.gov.cn/')
    },
    goGonganBeian () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010702503123')
    },
    toFot (item) {
      if (item.to == '/about') {
        this.$store.commit('increment2', 'he')
      }
      if (item.to != this.$route.path) {
        this.$router.push(item.to)
      }
      if (item.str == '品牌塑造') {
        this.$store.commit('increment1', 1)
      } else {
      }
    },
    toFot1 (str) {
      if (this.$route.path != '/cooperation') {
        this.$router.push('/cooperation')
      }
      this.$store.commit('increment', str)
    },
    toFot2 (str) {
      if (this.$route.path != '/about') {
        this.$router.push('/about')
      }
      this.$store.commit('increment2', str)
    }
  },
  created () {},
  mounted () {
    // window.addEventListener('scroll',this.handleScroll)
  }
}
</script>

<style scoped>
.footer {
  background-color: #302f2e;
  padding-top: 60px;
}
.footer_1 {
  display: flex;
  justify-content: space-between;
}
/* .footer_1>div:nth-of-type(1),.footer_1>div:nth-of-type(2),.footer_1>div:nth-of-type(3){
  width: 22%;
}
.footer_1>div:nth-of-type(4){
  width: 34%;
} */
.footer > div {
  width: 70%;
  margin: 0 auto;
}
.footer_1 h5 {
  color: #ffffff;
  font-weight: 200;
  font-size: 16px;
}
.footer_1 button {
  color: #ffffff;
  margin-top: 20px;
  font-size: 14px;
  opacity: 0.5;
  background: transparent;
  cursor: pointer;
}
.footer_1 button:active {
  opacity: 1;
}
.footer_1 p {
  color: #ffffff;
  margin-top: 20px;
  font-size: 14px;
  display: inline-block;
  opacity: 0.5;
}
.footer_1 span {
  color: #ffffff;
  font-size: 14px;
}
.footer_2 {
  height: 1px;
  background: #bfbfbf;
  margin-top: 30px;
}
.footer_3 {
  height: 118px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.footer_3 p {
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue